export  default {
    setTickets(state, payload) {
        state.tickets = payload;
    },
    setTicketTypes(state, payload) {
        state.ticketTypes = payload;
    },
    setTicketStatuses(state, payload) {
        state.ticketStatuses = payload;
    },
    setTicketNotes(state, payload) {
        state.ticketNotes = payload;
    },

};